import { useState } from "react";

const MissingTimeEntries = ({ users, compact = false }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="missing-time-entries">
      {compact ? (
        <span
          className="missing-time-details-btn missing-time-details-btn--warn"
          onClick={() => setExpanded(!expanded)}
        >
          {users.length} missing
        </span>
      ) : (
        <>
          ❌ {users.length} people are missing time entries{" "}
          <span
            className="missing-time-details-btn"
            onClick={() => setExpanded(!expanded)}
          >
            See details
          </span>
        </>
      )}
      {expanded && (
        <div className="missing-time-popup">
          <div className="missing-time-popup-header">
            <span>Missing Time Entries</span>
            <button
              className="missing-time-popup-close"
              onClick={() => setExpanded(false)}
            >
              ✕
            </button>
          </div>
          {users.map((user, index) => {
            const newCompany =
              index === 0 || users[index - 1].companyName !== user.companyName;

            return (
              <div key={user.id}>
                {newCompany && (
                  <div className="missing-time-company">{user.companyName}</div>
                )}

                <div className="missing-time-user">
                  <span className="missing-time-name">
                    {user.first_name} {user.last_name}
                  </span>

                  <span className="missing-time-hours">
                    {user.missingHours.toFixed(1)} t
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MissingTimeEntries;
